import { render, staticRenderFns } from "./tableColumn.vue?vue&type=template&id=4cf88479&"
import script from "./tableColumn.vue?vue&type=script&lang=js&"
export * from "./tableColumn.vue?vue&type=script&lang=js&"
import style0 from "./tableColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tableColumn.vue"
export default component.exports